import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const addStatusCapService = (
  access_token,
  userId,
  globalDateFormat,
  data,
) => {
  try {
    return axios.post(
      `${api}/Study/AddCap?UserId=${userId}&GlobalDateFormat=${globalDateFormat}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const deleteCapService = (
  access_token,
  capId,
  capLevelTypeId,
  siteId = null,
  userId,
  globalDateFormat,
) => {
  try {
    const url =
      `${api}/Study/DeleteCap?CapId=${capId}&CapLevelTypeId=${capLevelTypeId}&UserId=${userId}&GlobalDateFormat=${globalDateFormat}` +
      (siteId ? `&SiteId=${siteId}` : "");
    return axios.get(url, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const updateCapsService = (
  access_token,
  capLevelTypeId,
  siteId = null,
  userId,
  globalDateFormat,
  data,
) => {
  try {
    const url =
      `${api}/Study/UpdateCaps?CapLevelTypeId=${capLevelTypeId}&UserId=${userId}&GlobalDateFormat=${globalDateFormat}` +
      (siteId ? `&SiteId=${siteId}` : "");
    return axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const addCountryCapService = (access_token, data) => {
  try {
    return axios.post(`${api}/Study/AddCountryCap`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const addStrataCapService = (access_token, data) => {
  try {
    return axios.post(`${api}/Study/AddStrataCap`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};
